(function(wndw) {
  var jadify = function(jade, _t, _h) {
    var yudify = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (_t) {
buf.push("<div tabindex=\"0\" aria-label=\"Playback Rate\" class=\"c-playback-rate-menu-section\"><div class=\"vjs-menu-title\"><h3 class=\"menu-section-title headline-1-text\">" + (jade.escape((jade_interp = _t("Playback Rate")) == null ? '' : jade_interp)) + "</h3></div><div class=\"c-menu-divider\"></div><div class=\"c-playback-rate-button-container\"><button data-js=\"c-playback-rate-minus-button\" aria-label=\"Playback Rate Minus\" class=\"c-playback-rate-button\"><em class=\"cif-minus\"></em></button><span data-js=\"c-playback-rate-text\" class=\"c-playback-rate-text\"></span><button data-js=\"c-playback-rate-plus-button\" aria-label=\"Playback Rate Plus\" class=\"c-playback-rate-button\"><em class=\"cif-plus\"></em></button></div></div>");}.call(this,"_t" in locals_for_with?locals_for_with._t:typeof _t!=="undefined"?_t:undefined));;return buf.join("");
};
    return function(locals) {
      if (locals) {
        if ("_t" in locals) { _t = locals._t.merge(_t); }
        // Jade helper objects must define this merge method.
      }
      return yudify(locals);
    };
  };
  if(typeof define === "function" && define.amd) {
    define([
      "js/vendor/jade"
      ,"i18n!bundles/videojs/layout/nls/playbackRateMenuSection"
    ], function(
      jade
      ,_t
    ) {
      var _h;
      return jadify(jade, _t, _h);
    });
  } else {
    wndw.jade.templates["bundles.videojs.layout.playbackRateMenuSection"] = jadify(wndw.jade.helpers);
  }
})(window);
